import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-accept-invite',
  templateUrl: './accept-invite.component.html',
  styleUrls: ['./accept-invite.component.scss'],
})
export class AcceptInviteComponent implements OnInit {
  brand = environment.brand;

  password: string;
  confirmPassword: string;

  isLoading: boolean;
  error: any;

  passwordRevealed = false;

  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute) {}

  public ngOnInit(): void {}

  public async acceptInvite() {
    if (this.isLoading) return;
    const token = await this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      this.error = 'Token missing from URL. Please open the link from the email again.';
      return;
    }

    if (!this.password || !this.confirmPassword) {
      this.error = 'Please enter a password.';
      return;
    }

    if (this.password !== this.confirmPassword) {
      this.error = 'Please make sure the passwords match.';
      return;
    }

    try {
      this.error = null;
      this.isLoading = true;
      const { admin } = await this.authService.acceptInvitation(token, this.password.trim());
      this.router.navigate(['login'], { queryParams: { from: 'accept-invite', email: admin.email } }).then();
    } catch (error) {
      this.error = error;
    } finally {
      this.isLoading = false;
    }
  }
}
